import { render, staticRenderFns } from "./StatsComplimentsModal.vue?vue&type=template&id=42a8f079&"
import script from "./StatsComplimentsModal.vue?vue&type=script&lang=js&"
export * from "./StatsComplimentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports